import axios from "axios";
import AuthenticationInterceptor
  from "../../components/core/authentication/AuthenticationInterceptor";
import {environment} from "@/environments/environment";
import PrefManager from "@/data/model/PrefManager";
import OAuthTokenRepository from "@/repositories/oauth/OAuthTokenRepository";
import EncryptionDecryptionUtils from "../../utils/EncryptionDecryptionUtils";
import {Constants} from "@/components/Constants";

export const MifosRepository = axios.create({
  baseURL: environment.serverUrl,
  headers: {
    "Content-Type": "application/json",
    "Fineract-Platform-TenantId": environment.fineractPlatformTenantId
  }
});

MifosRepository.interceptors.request.use(
    config => {
      if (AuthenticationInterceptor.getAuthorizationHeader()) {
        config.headers["Authorization"] = AuthenticationInterceptor.getAuthorizationHeader();
      }
      if (requestHeaders.contentType) {
        config.headers["Content-Type"] = requestHeaders.contentType;
      }
      // Do something before request is sent
      if(environment.encryptRequest && !(config.data instanceof FormData)){
        config.headers["X-Data-Security"] = true;
        config.headers["Content-Type"] = "text/plain";
        let body = config.data;
        if(body){
          let encryptedBody = EncryptionDecryptionUtils.encryptRequestIfRequired(body);
          config.data = encryptedBody;
        }
      }else{
        delete config.headers["X-Data-Security"];
        config.headers["Content-Type"] = requestHeaders.contentType;
      }
      return config;
    },
    error => {
      // Do something with request error
      return Promise.reject(error);
    }
);

MifosRepository.interceptors.response.use(
    config => {
      if(config.config.headers && config.config.headers['X-Data-Security']){
        let encryptedResponse = config.data;
        let decryptedResponse = EncryptionDecryptionUtils.decryptResponseIfRequired(encryptedResponse);
        config.data = decryptedResponse;
      }
      return config;
    },
    error => {
      // Do something with response error
      if (error && error.response && error.response.status === 401) {
        const oauthRefreshToken = PrefManager.getOauthRefreshToken();
        if (oauthRefreshToken
            && environment.authenticationType === Constants.AUTH_TYPE_OAUTH
        ) {
          const refreshTokenReq = {refresh_token: oauthRefreshToken};
          return OAuthTokenRepository.refreshOAuthToken(refreshTokenReq)
          .then(refreshTokenRes => {
            PrefManager.setOauthData(refreshTokenRes.data);
            AuthenticationInterceptor.setAuthorizationToken(
                PrefManager.getOauthAccessToken()
            );

            return MifosRepository.request(error.config);
          })
          .catch(oauthRefreshTokenError => {
            return Promise.reject(oauthRefreshTokenError);
          })
        } else {
          return Promise.reject(error);
        }
      } else {
        return Promise.reject(error);
      }
    }
);

let requestHeaders = {
  contentType: "application/json"
};

export default {
  setContentType(contentType) {
    requestHeaders.contentType = contentType;
  }
}
